import React from 'react';
import { Card, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { ControlTowerQueryParams } from '@/services/manufacturingControlTower.service';
import { useControlTowerMaterial } from '@/hooks/useManufacturingControlTower';

const MaterialReadinessCenter: React.FC<{ filters?: ControlTowerQueryParams }> = ({ filters }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useControlTowerMaterial(filters);
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];

  return (
    <Card id="material" title="Material readiness center" style={{ marginTop: 16 }}>
      <Table
        size="small"
        loading={isLoading}
        rowKey="work_order_id"
        dataSource={rows}
        onRow={(r) => ({
          onClick: () => navigate(`/mfg/work-orders/${r.work_order_id}`),
          style: { cursor: 'pointer' },
        })}
        columns={[
          { title: 'WO', dataIndex: 'work_order_number' },
          { title: 'Customer', dataIndex: 'customer_name' },
          { title: 'Project', dataIndex: 'project_name' },
          { title: 'Open MRs', dataIndex: 'open_mr_count', width: 90 },
          {
            title: 'MR statuses',
            dataIndex: 'mr_statuses',
            render: (s: string[]) => (s || []).join(', '),
          },
          { title: 'Pending stages', dataIndex: 'stages_pending', width: 110 },
        ]}
        pagination={{ pageSize: 15 }}
      />
    </Card>
  );
};

export default MaterialReadinessCenter;
